import _ from 'lodash'
import { useEffect, useState } from 'react'

const useDebounce = (value: any, delayMs?: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(
    () => {
      let timeoutRef
      if (!_.isNumber(delayMs) || delayMs === 0) {
        setDebouncedValue(value)
      } else {
        timeoutRef = setTimeout(() => setDebouncedValue(value), delayMs)
      }
      return () => {
        if (timeoutRef) {
          clearTimeout(timeoutRef)
        }
      }
    },
    [value]
  )

  return debouncedValue
}

export default useDebounce
